import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import {
  fetchSuiteAppsRuntimeConfig,
  type SuiteAppApiItem,
  type SuiteAppsRuntimePayload,
} from "./suiteAppsLoader";

export interface SuiteRuntimeConfigProviderProps {
  children: React.ReactNode;
  appId: string;
  getAccessToken: () => Promise<string | null>;
}

const RuntimeContext = createContext<SuiteAppApiItem | null>(null);

export function useCurrentAppRuntimeConfig(): SuiteAppApiItem | null {
  return useContext(RuntimeContext);
}

export const SuiteRuntimeConfigProvider: React.FC<SuiteRuntimeConfigProviderProps> = ({
  children,
  appId,
  getAccessToken,
}) => {
  const [payload, setPayload] = useState<SuiteAppsRuntimePayload | null>(null);

  useEffect(() => {
    let cancelled = false;
    void fetchSuiteAppsRuntimeConfig(getAccessToken).then((data) => {
      if (!cancelled) setPayload(data);
    });
    return () => {
      cancelled = true;
    };
  }, [getAccessToken]);

  const value = useMemo(() => payload?.by_app_id?.[appId] ?? null, [appId, payload]);

  return <RuntimeContext.Provider value={value}>{children}</RuntimeContext.Provider>;
};
